"use client"
import { BookOpen } from "lucide-react";

export default function References({ references }) {
    if (!references || references.length === 0) return null;

    return (
        <div className="pt-2">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2">
                <BookOpen className="w-4 h-4 sm:w-5 sm:h-5 text-[#0B7BC1] flex-shrink-0" />
                References
            </h3>
            <ol className="space-y-2">
                {references.map((ref, index) => (
                    <li key={index} className="text-sm text-gray-700 flex gap-2">
                        <span className="text-gray-400 flex-shrink-0 font-medium">[{index + 1}]</span>
                        <div className="min-w-0 flex-1 break-words">
                            <span className="break-words">{ref.citation}</span>
                            {ref.year && <span className="text-gray-500 ml-1 break-words">({ref.year})</span>}
                            {ref.guideline_body && <span className="text-gray-500 ml-1 break-words">— {ref.guideline_body}</span>}
                            {ref.url && (
                                <a href={ref.url} target="_blank" rel="noopener noreferrer"
                                    className="ml-1 text-[#0B7BC1] hover:underline text-xs break-all">
                                    [Link]
                                </a>
                            )}
                        </div>
                    </li>
                ))}
            </ol>
        </div>
    );
}
